import { useLazyGetFilteredReceiptsQuery, useLazyGetFilteredUsersQuery, useLazyGetFilteredWinnersQuery } from "../store/services/reportsServices";
import * as XLSX from 'xlsx-js-style';
import { useEffect, useState } from 'react';
import { useLazyGetGamesQuery } from "../store/services/gameServices";
import { useLazyGetComplaintsQuery } from "../store/services/complaintsServices";

export const useExportData = () => {
    const [getReceiptsData] = useLazyGetFilteredReceiptsQuery();
    const [getUsersData] = useLazyGetFilteredUsersQuery();
    const [getWinnersData] = useLazyGetFilteredWinnersQuery();
    const [getGamesData] = useLazyGetGamesQuery();
    const [getComplaintsData] = useLazyGetComplaintsQuery()
    const [data, setData] = useState([]);

    useEffect(() => {
        console.log({ data })
    }, [data])

    const exportDataToExcel = async (params, title, filters = {}) => {
        console.log("PARAMS NE FUNKSION", { params })
        let fetchedData = [];

        try {
            if (params?.category === 'receipts') {
                fetchedData = await getReceiptsData({ params: { ...params, limit: 1000000, page: 1 } }).unwrap();
            } else if (params?.category === 'users' || !params?.category) {
                fetchedData = await getUsersData({ ...params, limit: 1000000, page: 1 }).unwrap();
            } else if (params?.category === 'winners') {
                fetchedData = await getWinnersData({ params: { ...params, limit: 1000000, page: 1 } }).unwrap();
            } else if (params?.category === 'games') {
                fetchedData = await getGamesData({ params: { ...params, limit: 1000000, page: 1 } }).unwrap();
            } else if (params?.category === 'complaints') {
                fetchedData = await getComplaintsData({ ...params, limit: 1000000, page: 1 }).unwrap();
            }

            const rawRows = fetchedData?.data?.data || [];

            // Remove unwanted properties
            const propertiesToRemove = ['municipality_no', 'winner_id', 'game_id', 'updated_at'];
            const rows = rawRows.map(row => {
                const cleanedRow = { ...row };
                propertiesToRemove.forEach(prop => {
                    delete cleanedRow[prop];
                });
                return cleanedRow;
            });

            setData(rows); // optional, for debugging/logging elsewhere

            // let description = Object.keys(filters).length > 0 ? "Filterat e aplikuar: \n" : '';

            // ... (same filter description code as you wrote)

            // Initialize worksheet
            const ws = XLSX.utils.json_to_sheet([]);

            // Add params information (exclude page and category)
            const filteredParams = { ...params };
            delete filteredParams.page;
            delete filteredParams.category;
            const cleanedParams = Object.fromEntries(
                Object.entries(filteredParams).filter(([_, value]) =>
                    value !== null && value !== undefined && value !== '' && !(Array.isArray(value) && value.length === 0)
                )
            );

            const paramsText = `Filters:\n${Object.entries(cleanedParams)
                .map(([key, value]) => `${key}: ${value}`)
                .join(', ')}`;

            XLSX.utils.sheet_add_aoa(ws, [[paramsText]], { origin: { r: 0, c: 1 } });

            let dataStartRow = 3;

            // if (description.trim()) {
            //     const descriptionLines = description.split("\n").filter(line => line.trim() !== "");
            //     descriptionLines.forEach((line, index) => {
            //         XLSX.utils.sheet_add_aoa(ws, [[line]], { origin: { r: index + 1, c: 1 } });
            //     });
            //     dataStartRow = descriptionLines.length + 2;
            // }

            if (rows.length > 0) {
                // First, find all array properties and determine max array lengths
                const arrayProperties = {};
                rows.forEach(row => {
                    Object.keys(row).forEach(key => {
                        if (Array.isArray(row[key])) {
                            arrayProperties[key] = Math.max(arrayProperties[key] || 0, row[key].length);
                        }
                    });
                });

                const processedRows = rows.map(row => {
                    const processedRow = {};
                    Object.keys(row).forEach(key => {
                        if (Array.isArray(row[key])) {
                            // Create separate columns for each array element
                            for (let i = 0; i < arrayProperties[key]; i++) {
                                const columnName = `${key}_${i + 1}`;
                                processedRow[columnName] = row[key][i] || '';
                            }
                        } else {
                            processedRow[key] = row[key];
                        }
                    });
                    return processedRow;
                });

                const columnKeys = Object.keys(processedRows[0]);

                // Add header row with styling
                const headerRow = dataStartRow - 1;
                columnKeys.forEach((key, index) => {
                    const cellAddress = XLSX.utils.encode_cell({ r: headerRow, c: index + 1 });
                    const headerName = key.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
                    ws[cellAddress] = {
                        v: headerName,
                        t: 's',
                        s: {
                            fill: { fgColor: { rgb: "000000" } },
                            font: { color: { rgb: "FFFFFF" }, bold: true, sz: 11 },
                            alignment: { horizontal: "center" }
                        }
                    };
                });

                XLSX.utils.sheet_add_json(ws, processedRows, {
                    origin: { r: dataStartRow, c: 1 },
                    skipHeader: true,
                });

                const colWidths = columnKeys.map((key) => {
                    const maxLength = Math.max(
                        key.length,
                        ...processedRows.map(row => (row[key] ? row[key].toString().length : 0))
                    );
                    return { wch: maxLength + 2 };
                });
                ws["!cols"] = [{ wch: 2 }, ...colWidths];
            } else {
                XLSX.utils.sheet_add_aoa(ws, [['No data available']], { origin: { r: dataStartRow, c: 1 } });
            }

            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, title);
            XLSX.writeFile(wb, `${title}.xlsx`);

        } catch (err) {
            console.error('Export error:', err);
        }
    };

    return { exportDataToExcel, data };
};